<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4827_33)">
<path d="M12 0.5L15.5 0.5L15.5 4" stroke="currentColor"/>
<path d="M4 15.5L0.5 15.5L0.5 12" stroke="currentColor"/>
<rect x="3.5" y="3.5" width="9" height="9" stroke="currentColor"/>
<path d="M12.5 3.5L3.5 12.5H12.5V3.5Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_4827_33">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
